import "react-data-grid/lib/styles.css";
import "./dataset-style.scss";

import {
  CAlert,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CContainer,
  CForm,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
  CSelect,
  CSwitch,
} from "@coreui/react";
import React, { useEffect, useMemo, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import WhereFilter, {
  AddWhereFilterButton,
  initialWhereFilterValue,
} from "src/reusable/WhereFilter";
import { DatasetFieldSelect, DatasetSelect } from "../forms/DatasetModals";
import {
  AutomatedTrendCodingProductPatchModalButton,
  TrendCodingProduct,
  TrendCodingProductPatchModalButton,
} from "../products/cap-ai/cap-trending/trendingDashboard";
import {
  useDatasetFields,
  useGetAnalytic,
  useGetAnalyticResults,
  useGetDatasetModelVersions,
  useGetScoredDataset,
  useUpsertAnalytic,
} from "./services/DatasetServices";

import PropTypes from "prop-types";
import DataGrid from "react-data-grid";
import { MdOutlineScatterPlot } from "react-icons/md";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Can } from "src/helpers/Auth";
import ReactQueryLoading from "src/reusable/ReactQueryLoading";
import { useGetBucket } from "../buckets/BucketServices";
import { BucketVisPackage } from "../buckets/BucketVisualization";
import { ScoreModelParamsLimit } from "../models/ModelButtons";
import { useGetModelVersionByVersionId } from "../models/ModelService";
import { ScoredDataError } from "./components/ScoredDataError";
import { DatasetScoreWarning } from "./DatasetComponents";
import DatasetInfo from "./DatasetInfo";
import DatasetAnalyticsExportButton from "./components/DatasetAnalyticsExportButton";
import { Button, Stack } from "@mui/material";
import RawPredictionsModal from "./components/RawPredictionsModal";

export const ModelVersionSelector = (props) => {
  const [modelVersionId, setModelVersionId] = useState(props.modelVersionId);
  const [modelVersion, setModelVersion] = useState(props.modelVersion);
  useEffect(() => {
    setModelVersionId(props.modelVersionId);
  }, [props.modelVersionId]);
  useEffect(() => {
    setModelVersion(props.modelVersion);
  }, [props.modelVersion]);

  const {
    data: modelVersions,
    isLoading: isModelVersionsLoading,
    status: modelVersionsStatus,
    error: modelVersionsError,
  } = useGetDatasetModelVersions(props.datasetId);

  const getModelVersion = (_modelVersionId) => {
    let mv = modelVersions.filter(
      (modelVersion) => modelVersion.id == _modelVersionId,
    )[0];
    setModelVersion(mv);
  };

  useEffect(() => {
    // if props.setSuccessScore exists, then use it

    props.setSuccessScore & props.setSuccessScore(modelVersionsStatus);
  }, [modelVersionsStatus]);
  let valueInput = modelVersionId || "Empty";
  useEffect(() => {
    if (modelVersions && modelVersionId) {
      valueInput = modelVersionId;
    }
  }, [modelVersions, modelVersionId]);

  return (
    <Can
      perform="model:read"
      yes={() => (
        <>
          <CCard>
            <CCardHeader>
              <h5 style={{ float: "left" }}>Choose a model</h5>
              <AutomatedTrendCodingProductPatchModalButton />
            </CCardHeader>
            <CCardBody style={{ padding: "10px 20px" }}>
              <CForm>
                <CFormGroup row>
                  <CCol md="3">
                    <CLabel htmlFor="model-version-select">Model</CLabel>
                  </CCol>
                  <CCol xs="12" md="9">
                    <ReactQueryLoading
                      isLoading={isModelVersionsLoading}
                      status={modelVersionsStatus}
                      error={modelVersionsError}
                      loadingHeight={"25em"}
                    >
                      {modelVersions && (
                        <CSelect
                          id="model-version-select"
                          name="model-version-select"
                          value={valueInput}
                          onChange={(e) => {
                            if (props.onModelVersionId) {
                              props.onModelVersionId(
                                e.target.value === "" ? null : e.target.value,
                              );
                            } else {
                              setModelVersionId(
                                e.target.value === "" ? null : e.target.value,
                              );
                            }
                            getModelVersion(
                              e.target.value === "" ? null : e.target.value,
                            );
                          }}
                          disabled={props.disabled}
                        >
                          <option value="">Select a model</option>
                          {modelVersions.map((_modelVersion) => (
                            <option
                              key={_modelVersion.id}
                              value={_modelVersion.id}
                            >
                              {`${_modelVersion.model_name} v${_modelVersion.version_number}`}
                            </option>
                          ))}
                        </CSelect>
                      )}
                    </ReactQueryLoading>
                  </CCol>
                </CFormGroup>
              </CForm>
              {modelVersionId && modelVersion && (
                <CRow>
                  <CCol xs="12">
                    <DatasetScoreWarning
                      canScore={modelVersion.is_deployed}
                      datasetId={props.datasetId}
                      modelVersionId={modelVersionId}
                      modelName={
                        modelVersion.model_name +
                        " " +
                        "v" +
                        modelVersion.version_number
                      }
                    />
                  </CCol>
                </CRow>
              )}
            </CCardBody>
          </CCard>
        </>
      )}
      no={() => (
        <CCard>
          <CCardHeader>
            <h5>You do not have permission to view models</h5>
          </CCardHeader>
        </CCard>
      )}
    />
  );
};

ModelVersionSelector.propTypes = {
  datasetId: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  modelVersionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  setSuccessScore: PropTypes.func,
  modelVersion: PropTypes.object,
  onModelVersionId: PropTypes.func,
};

ModelVersionSelector.defaultProps = {
  modelVersionId: null,
  disabled: false,
};

export const TimeSliceSelector = ({ value, disabled, onChange }) => {
  const [splitDates, setSplitDates] = useState(value);
  return (
    <>
      {splitDates.map((splitDate, idx) => {
        return (
          <div key={idx}>
            <div>
              <div style={{ float: "left" }}>
                <CInput
                  type="date"
                  name={`timeslice-split-select${idx}`}
                  id={`timeslice-split-select${idx}`}
                  onChange={(e) => {
                    //TODO: warn if splitDates aren't ordered
                    let newSplitDates = [...splitDates];
                    newSplitDates[idx] = e.target.value;
                    setSplitDates(newSplitDates);
                    onChange(newSplitDates);
                  }}
                  style={
                    splitDate
                      ? { maxWidth: "130px" }
                      : { maxWidth: "130px", backgroundColor: "#FEEFD0" }
                  }
                  value={splitDate}
                  disabled={disabled}
                />
              </div>
              <div
                style={{ float: "left", marginLeft: "10px", marginTop: "5px" }}
              >
                {!disabled && (
                  <>
                    <FaPlus
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        let newSplitDates = [...splitDates];
                        newSplitDates.splice(idx + 1, 0, "");
                        setSplitDates(newSplitDates);
                        onChange(newSplitDates);
                      }}
                    />
                    {splitDates?.length !== 1 && (
                      <FaMinus
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                        onClick={() => {
                          let newSplitDates = [...splitDates];
                          newSplitDates.splice(idx, 1);
                          setSplitDates(newSplitDates);
                          onChange(newSplitDates);
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            {idx !== 0 &&
              splitDate !== "" &&
              splitDates[idx - 1] >= splitDate && (
                <div style={{ float: "left" }}>
                  <CAlert
                    color="danger"
                    style={{ padding: "2px 5px", fontSize: "85%", margin: "0" }}
                  >
                    Split Dates must be in ascending order
                  </CAlert>
                </div>
              )}
          </div>
        );
      })}
    </>
  );
};

TimeSliceSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

TimeSliceSelector.defaultProps = {
  disabled: false,
  onChange: () => {},
};

// Utility function to normalize values to null instead of undefined
const normalizeToNull = (v) => {
  if (v === undefined || v === "") {
    return null;
  }
  return v;
};

export const DatasetModelParamsSelector = (props) => {
  const [modelLabelClassId, setModelLabelClassId] = React.useState("");
  const [limitResults, setLimitResults] = React.useState("aboveprob");
  const [resultsLimitedTo, setResultsLimitedTo] = React.useState(75.0);
  const [aggregation, setAggregation] = React.useState("count");
  const [sliceByColumns, setSliceByColumns] = React.useState([]);
  const [sliceByStats, setSliceByStats] = React.useState("rel_diff");
  const [sliceProportional, setSliceProportional] = React.useState(true);
  const [sliceExcludeFromAverage, setSliceExcludeFromAverage] =
    React.useState(true);
  const [timeSliceColumn, setTimeSliceColumn] = React.useState("");
  const [timeSliceAggregation, setTimeSliceAggregation] =
    React.useState("month");
  const [timeSliceSplits, setTimeSliceSplits] = React.useState(null);
  const [includeFirstTimePeriod, setIncludeFirstTimePeriod] =
    React.useState(true);
  const [includeLastTimePeriod, setIncludeLastTimePeriod] =
    React.useState(true);
  const [timeSliceStats, setTimeSliceStats] = React.useState("rel_diff");
  const [timeProportional, setTimeProportional] = React.useState(true);
  const [dataFilters, setDataFilters] = useState([]);
  const [benchmarkDatasetId, setBenchmarkDatasetId] = React.useState("");
  const [benchmarkLabelField, setBenchmarkLabelField] = React.useState("");
  const [benchmarkField, setBenchmarkField] = React.useState("");
  const splitDatesValid = () => {
    let datesValid = true;
    if (timeSliceSplits === null) {
      return false;
    }
    timeSliceSplits.forEach((split) => {
      if (split === "") {
        datesValid = false;
      }
    });
    return datesValid;
  };

  useEffect(() => {
    // reset timeslice split if timeSliceAggregation is changed from split
    if (timeSliceAggregation !== "split") {
      setTimeSliceSplits(null); // Reset the timeslice splits, make sure this reinit state gets set the same as the parent prop, which is undefined
    }
  }, [timeSliceAggregation]);

  useEffect(() => {
    if (benchmarkDatasetId === "") {
      // reset selections if dataset deselected
      setBenchmarkLabelField("");
      setBenchmarkField("");
    }
  }, [benchmarkDatasetId]);

  const getStatsParams = () => {
    return {
      modelLabelClassId: normalizeToNull(modelLabelClassId),
      limitResults: normalizeToNull(limitResults),
      resultsLimitedTo: resultsLimitedTo,
      aggregation: normalizeToNull(aggregation),
      sliceByColumns: sliceByColumns,
      sliceByStats: normalizeToNull(sliceByStats),
      sliceProportional: sliceProportional,
      sliceExcludeFromAverage: sliceExcludeFromAverage,
      timeSliceColumn: normalizeToNull(timeSliceColumn),
      timeSliceAggregation: normalizeToNull(timeSliceAggregation),
      timeSliceSplits: normalizeToNull(timeSliceSplits),
      includeFirstTimePeriod: includeFirstTimePeriod,
      includeLastTimePeriod: includeLastTimePeriod,
      timeSliceStats: normalizeToNull(timeSliceStats),
      timeProportional: timeProportional,
      dataFilters: dataFilters,
      benchmarkDatasetId: normalizeToNull(benchmarkDatasetId),
      benchmarkLabelField: normalizeToNull(benchmarkLabelField),
      benchmarkField: normalizeToNull(benchmarkField),
    };
  };

  useEffect(() => {
    if (modelLabelClassId) {
      props.onReady(getStatsParams());
    } else {
      props.onNotReady();
    }
  }, [
    modelLabelClassId,
    limitResults,
    resultsLimitedTo,
    aggregation,
    sliceByColumns,
    sliceByStats,
    sliceProportional,
    sliceExcludeFromAverage,
    timeSliceColumn,
    timeSliceSplits,
    timeSliceAggregation,
    includeFirstTimePeriod,
    includeLastTimePeriod,
    timeSliceStats,
    timeProportional,
    dataFilters,
    benchmarkDatasetId,
    benchmarkLabelField,
    benchmarkField,
  ]);

  const aggregationOptions = [
    { value: "count", label: "Count" },
    { value: "sum", label: "Sum of probabilities" },
  ];
  const statOptions = [
    { value: "rel_diff", label: "Relative Difference from Average" },
    { value: "abs_diff", label: "Absolute Difference from Average" },
    { value: "percentile", label: "Percentile" },
    { value: "oos_zscore", label: "Standard Deviations from Mean" },
  ];
  const timeStatOptions = statOptions.concat([
    {
      value: "pct_growth_from_previous_period",
      label: "Percent Growth from Previous Period",
    },
  ]);

  const {
    data: datasetColumns,
    isLoading: isDatasetColumnsLoading,
    status: datasetColumnsStatus,
    error: datasetColumnsError,
  } = useDatasetFields(props.datasetId);

  const {
    data: model,
    isLoading: isModelLoading,
    status: modelStatus,
    error: modelError,
  } = useGetModelVersionByVersionId(props.modelVersionId);

  useEffect(() => {
    // Default to the first modelLabelClassId
    if (
      model &&
      modelLabelClassId === "" &&
      model.model_label_classes.length > 0
    ) {
      setModelLabelClassId(model.model_label_classes[0].id);
    }
  }, [model]);

  useEffect(() => {
    if (props.statsParams) {
      setModelLabelClassId(
        normalizeToNull(props.statsParams.modelLabelClassId) || "",
      );
      setLimitResults(
        normalizeToNull(props.statsParams.limitResults) || "aboveprob",
      );
      setResultsLimitedTo(props.statsParams.resultsLimitedTo || 75.0);
      setAggregation(normalizeToNull(props.statsParams.aggregation) || "count");
      setSliceByColumns(props.statsParams.sliceByColumns || []);
      setSliceByStats(
        normalizeToNull(props.statsParams.sliceByStats) || "rel_diff",
      );
      setSliceProportional(props.statsParams.sliceProportional ?? true);
      setSliceExcludeFromAverage(
        props.statsParams.sliceExcludeFromAverage ?? true,
      );
      setTimeSliceColumn(
        normalizeToNull(props.statsParams.timeSliceColumn) || "",
      );
      setTimeSliceAggregation(
        normalizeToNull(props.statsParams.timeSliceAggregation) || "month",
      );
      setTimeSliceSplits(normalizeToNull(props.statsParams.timeSliceSplits));
      setIncludeFirstTimePeriod(
        props.statsParams.includeFirstTimePeriod ?? true,
      );
      setIncludeLastTimePeriod(props.statsParams.includeLastTimePeriod ?? true);
      setTimeSliceStats(
        normalizeToNull(props.statsParams.timeSliceStats) || "rel_diff",
      );
      setTimeProportional(props.statsParams.timeProportional ?? true);
      setDataFilters(props.statsParams.dataFilters || []);
      setBenchmarkDatasetId(
        normalizeToNull(props.statsParams.benchmarkDatasetId) || "",
      );
      setBenchmarkLabelField(
        normalizeToNull(props.statsParams.benchmarkLabelField) || "",
      );
      setBenchmarkField(
        normalizeToNull(props.statsParams.benchmarkField) || "",
      );
    }
  }, [props.statsParams]);
  const [filterRowsReady, setFilterRowReady] = useState([]);

  const setFilterRowIdxReady = (idx, isReady) => {
    let newFilterRowReady = [...filterRowsReady];
    newFilterRowReady[idx] = isReady;
    setFilterRowReady(newFilterRowReady);
  };

  return (
    <Can
      perform="dataset_data:read"
      // TODO: Fix eslint line complexity

      yes={() => (
        <>
          <div
            style={{
              display: props.isAdvancedAnalyticOptions ? "inline" : "none",
            }}
          >
            <CForm>
              {/* Advanced Analytic Options Form */}
              <CFormGroup row>
                <CCol md="3">
                  <CLabel htmlFor="bucket-select" className="col-form-label">
                    Model Prediction
                  </CLabel>
                </CCol>
                <CCol xs="12" md="9">
                  <ReactQueryLoading
                    loadingHeight={"40px"}
                    isLoading={isModelLoading}
                    status={modelStatus}
                    error={modelError}
                  >
                    {model && (
                      <CSelect
                        name="bucket-select"
                        id="bucket-select"
                        onChange={(e) => setModelLabelClassId(e.target.value)}
                        value={modelLabelClassId}
                        disabled={props.disabled}
                      >
                        <option value="">-</option>
                        {model.model_label_classes &&
                          model.model_label_classes.map((mac) => (
                            <option key={mac.model_output_name} value={mac.id}>
                              {mac.name}
                            </option>
                          ))}
                      </CSelect>
                    )}
                  </ReactQueryLoading>
                </CCol>
              </CFormGroup>
              {modelLabelClassId && (
                <>
                  <CFormGroup row>
                    <CCol md="3">
                      <CLabel className="col-form-label" htmlFor="limitresults">
                        Limit Predictions
                      </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                      <ScoreModelParamsLimit
                        limitResults={limitResults}
                        resultsLimitedTo={resultsLimitedTo}
                        onLimitResultsChange={setLimitResults}
                        onResultsLimitedToChange={setResultsLimitedTo}
                        disabled={props.disabled}
                      />
                    </CCol>
                  </CFormGroup>
                  <CFormGroup row>
                    <CCol md="3">
                      <CLabel
                        htmlFor="aggregation-select"
                        className="col-form-label"
                      >
                        How to aggregate predictions
                      </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                      <CSelect
                        name="aggregation-select"
                        id="aggregation-select"
                        value={aggregation}
                        onChange={(e) => setAggregation(e.target.value)}
                        disabled={props.disabled}
                      >
                        {aggregationOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </CSelect>
                    </CCol>
                  </CFormGroup>
                  <CFormGroup row>
                    <CCol md="3">
                      <CLabel
                        htmlFor="sliceby-select"
                        className="col-form-label"
                      >
                        Field to slice by{" "}
                        <span className="optionaltext">(optional)</span>
                      </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                      <ReactQueryLoading
                        isLoading={isDatasetColumnsLoading}
                        status={datasetColumnsStatus}
                        error={datasetColumnsError}
                      >
                        {datasetColumns && (
                          <Select
                            name="sliceby-select"
                            id="sliceby-select"
                            isMulti
                            className="field-multi-option"
                            value={sliceByColumns.map((sbc) => ({
                              value: sbc,
                              label: sbc,
                            }))}
                            onChange={(selected) => {
                              setSliceByColumns(selected.map((s) => s.value));
                            }}
                            isDisabled={props.disabled}
                            options={datasetColumns.map((dsc) => ({
                              value: dsc.field_name,
                              label: dsc.field_name,
                            }))}
                          />
                        )}
                      </ReactQueryLoading>
                    </CCol>
                  </CFormGroup>
                  {sliceByColumns?.length > 0 && (
                    <CFormGroup row>
                      <CCol md="3">
                        <CLabel
                          htmlFor="slicestats-select"
                          className="col-form-label"
                        >
                          Analyze Slices by
                        </CLabel>
                      </CCol>
                      <CCol xs="12" md="9">
                        <CSelect
                          name="slicestats-select"
                          id="slicestats-select"
                          value={sliceByStats}
                          onChange={(e) => setSliceByStats(e.target.value)}
                          disabled={props.disabled}
                        >
                          <option value="">-</option>
                          {statOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </CSelect>
                      </CCol>
                      <CRow style={{ marginTop: "10px" }}>
                        <CCol xs="0" md="3">
                          {/* Spacing */}
                        </CCol>
                        <CCol xs="12" md="9" style={{ paddingLeft: "25px" }}>
                          <input
                            type="checkbox"
                            id="slice-proportional-checkbox"
                            name="slice-proportional"
                            checked={sliceProportional}
                            value={sliceProportional}
                            onChange={(e) =>
                              setSliceProportional(e.target.checked)
                            }
                            disabled={props.disabled}
                          />
                          <CLabel
                            variant="checkbox"
                            htmlFor="slice-proportional-checkbox"
                          >
                            &nbsp;Use proportions instead of absolute counts for
                            slice stats
                          </CLabel>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol xs="0" md="3">
                          {/* Spacing */}
                        </CCol>
                        <CCol xs="12" md="9" style={{ paddingLeft: "25px" }}>
                          <input
                            type="checkbox"
                            id="slice-exclude-from-average-checkbox"
                            name="slice-exclude-from-average"
                            checked={sliceExcludeFromAverage}
                            value={sliceExcludeFromAverage}
                            onChange={(e) =>
                              setSliceExcludeFromAverage(e.target.checked)
                            }
                            disabled={props.disabled}
                          />
                          <CLabel
                            variant="checkbox"
                            htmlFor="slice-exclude-from-average-checkbox"
                          >
                            &nbsp;Exclude the slice being analyzed from the
                            group average
                          </CLabel>
                        </CCol>
                      </CRow>
                    </CFormGroup>
                  )}
                  <CFormGroup row>
                    <CCol xs="6" md="3">
                      <CLabel
                        htmlFor="timeslice-select"
                        className="col-form-label"
                      >
                        Analyze Across Time{" "}
                        <span className="optionaltext">(optional)</span>
                      </CLabel>
                    </CCol>
                    <CCol xs="6" md="3">
                      <ReactQueryLoading
                        isLoading={isDatasetColumnsLoading}
                        status={datasetColumnsStatus}
                        error={datasetColumnsError}
                      >
                        {datasetColumns && (
                          <CSelect
                            name="timeslice-select"
                            id="timeslice-select"
                            value={timeSliceColumn}
                            onChange={(e) => setTimeSliceColumn(e.target.value)}
                            disabled={props.disabled}
                          >
                            <option value="">-</option>
                            {datasetColumns.map((dsc) => (
                              <option
                                key={dsc.field_name}
                                value={dsc.field_name}
                              >
                                {dsc.field_name}
                              </option>
                            ))}
                          </CSelect>
                        )}
                      </ReactQueryLoading>
                    </CCol>
                    {timeSliceColumn && (
                      <>
                        <CCol xs="6" md="3">
                          <CLabel
                            htmlFor="timeslice-aggregation-select"
                            className="col-form-label"
                          >
                            Time Aggregation
                          </CLabel>
                        </CCol>
                        <CCol xs="6" md="3">
                          {datasetColumns && (
                            <CSelect
                              name="timeslice-aggregation-select"
                              id="timeslice-aggregation-select"
                              onChange={(e) => {
                                setTimeSliceAggregation(e.target.value);
                                if (
                                  e.target.value === "split" &&
                                  timeSliceSplits === null
                                ) {
                                  setTimeSliceSplits([""]);
                                }
                              }}
                              value={timeSliceAggregation}
                              disabled={props.disabled}
                            >
                              <option value="split">Split</option>
                              <option value="day">Day</option>
                              <option value="week">Week</option>
                              <option value="month">Month</option>
                              <option value="quarter">Quarter</option>
                              <option value="year">Year</option>
                            </CSelect>
                          )}
                        </CCol>
                        {timeSliceAggregation === "split" && (
                          <>
                            <CCol xs="0" md="6">
                              {/* Spacing */}
                            </CCol>
                            <CCol xs="6" md="3">
                              <CLabel
                                htmlFor="timeslice-split-select"
                                className="col-form-label"
                              >
                                Split Dates
                              </CLabel>
                            </CCol>
                            <CCol xs="6" md="3">
                              {datasetColumns && timeSliceSplits && (
                                <TimeSliceSelector
                                  value={timeSliceSplits}
                                  disabled={props.disabled}
                                  onChange={setTimeSliceSplits}
                                />
                              )}
                            </CCol>
                          </>
                        )}

                        {datasetColumns && (
                          <>
                            <CRow style={{ marginTop: "10px" }}>
                              <CCol xs="0" md="3">
                                {/* Spacing */}
                              </CCol>
                              <CCol
                                xs="12"
                                md="9"
                                style={{ paddingLeft: "25px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="include-first-time-period-checkbox"
                                  name="include-first-time-period"
                                  checked={includeFirstTimePeriod}
                                  onChange={(e) => {
                                    setIncludeFirstTimePeriod(e.target.checked);
                                  }}
                                  disabled={props.disabled}
                                />
                                <CLabel
                                  variant="checkbox"
                                  htmlFor="include-first-time-period-checkbox"
                                >
                                  &nbsp;Include first time period
                                </CLabel>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol xs="0" md="3">
                                {/* Spacing */}
                              </CCol>
                              <CCol
                                xs="12"
                                md="9"
                                style={{ paddingLeft: "25px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="include-last-time-period-checkbox"
                                  name="include-last-time-period"
                                  checked={includeLastTimePeriod}
                                  onChange={(e) =>
                                    setIncludeLastTimePeriod(e.target.checked)
                                  }
                                  disabled={props.disabled}
                                />
                                <CLabel
                                  variant="checkbox"
                                  htmlFor="include-last-time-period-checkbox"
                                >
                                  &nbsp;Include last time period
                                </CLabel>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol xs="0" md="3">
                                {/* Spacing */}
                              </CCol>
                              <CCol
                                xs="12"
                                md="9"
                                style={{ paddingLeft: "25px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="time-proportional-checkbox"
                                  name="time-proportional"
                                  checked={timeProportional}
                                  onChange={(e) =>
                                    setTimeProportional(e.target.checked)
                                  }
                                  disabled={props.disabled}
                                />
                                <CLabel
                                  variant="checkbox"
                                  htmlFor="time-proportional-checkbox"
                                >
                                  &nbsp;Use proportions instead of absolute
                                  counts for time stats
                                </CLabel>
                              </CCol>
                            </CRow>
                          </>
                        )}
                      </>
                    )}
                  </CFormGroup>
                  {timeSliceColumn && (
                    <CFormGroup row>
                      <CCol md="3">
                        <CLabel
                          htmlFor="timestats-select"
                          className="col-form-label"
                        >
                          Analyze Time by
                        </CLabel>
                      </CCol>
                      <CCol xs="12" md="9">
                        <CSelect
                          name="timestats-select"
                          id="timestats-select"
                          value={timeSliceStats}
                          onChange={(e) => setTimeSliceStats(e.target.value)}
                          disabled={props.disabled}
                        >
                          <option value="">-</option>
                          {timeStatOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </CSelect>
                      </CCol>
                    </CFormGroup>
                  )}
                  <CFormGroup row>
                    <CCol md="3">
                      <CLabel
                        htmlFor="benchmark-dataset-select"
                        className="col-form-label"
                      >
                        Benchmark Dataset{" "}
                        <span className="optionaltext">(optional)</span>
                      </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                      <DatasetSelect
                        datasetId={benchmarkDatasetId}
                        handleSelectedDataset={(x) => {
                          setBenchmarkDatasetId(x);
                        }}
                        disabled={props.disabled}
                      />
                      {benchmarkDatasetId && (
                        <>
                          <CFormGroup row style={{ marginTop: "10px" }}>
                            <CCol md="6">
                              <CLabel
                                htmlFor="benchmark-label-column-select"
                                className="col-form-label"
                              >
                                Benchmark Label Column{" "}
                                <span className="optionaltext">
                                  (should match model prediction column)
                                </span>
                              </CLabel>
                            </CCol>
                            <CCol xs="12" md="6">
                              <DatasetFieldSelect
                                datasetId={benchmarkDatasetId}
                                datasetField={benchmarkLabelField}
                                handleSelectedDatasetField={(x) => {
                                  setBenchmarkLabelField(x);
                                }}
                                useNameForValue={true}
                                disabled={props.disabled}
                              />
                            </CCol>
                          </CFormGroup>
                          <CFormGroup row>
                            <CCol md="6">
                              <CLabel
                                htmlFor="benchmark-value-column-select"
                                className="col-form-label"
                              >
                                Benchmark Value Column{" "}
                                <span className="optionaltext">
                                  (column with benchmark value)
                                </span>
                              </CLabel>
                            </CCol>
                            <CCol xs="12" md="6">
                              <DatasetFieldSelect
                                datasetId={benchmarkDatasetId}
                                datasetField={benchmarkField}
                                handleSelectedDatasetField={(x) => {
                                  setBenchmarkField(x);
                                }}
                                useNameForValue={true}
                                disabled={props.disabled}
                              />
                            </CCol>
                          </CFormGroup>
                        </>
                      )}
                    </CCol>
                  </CFormGroup>
                  <CFormGroup row>
                    <CCol md="3">
                      <CLabel
                        htmlFor="where-filter-select"
                        className="col-form-label"
                      >
                        Filters <span className="optionaltext">(optional)</span>
                      </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                      {dataFilters.length === 0 && (
                        <AddWhereFilterButton
                          onAddFilter={() => {
                            setDataFilters([initialWhereFilterValue]);
                          }}
                          disabled={props.disabled}
                        />
                      )}
                      {dataFilters.map((value, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              float: "left",
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <WhereFilter
                                datasetId={props.datasetId}
                                whereFilters={dataFilters}
                                fields={datasetColumns}
                                group="dataset"
                                includeHeader={index === 0}
                                addFilterEnabled={
                                  index === dataFilters.length - 1
                                }
                                removeFilterEnabled={true}
                                value={value}
                                onValidFilter={(newValue) => {
                                  if (
                                    JSON.stringify(newValue) !==
                                    JSON.stringify(dataFilters[index])
                                  ) {
                                    let newWhereFilters = [...dataFilters];
                                    newWhereFilters[index] = newValue;
                                    setDataFilters(newWhereFilters);
                                  }
                                }}
                                onAddFilter={() => {
                                  let newWhereFilters = [...dataFilters];
                                  newWhereFilters.splice(
                                    index + 1,
                                    0,
                                    initialWhereFilterValue,
                                  );
                                  setDataFilters(newWhereFilters);
                                }}
                                onRemoveFilter={() => {
                                  let newWhereFilters = [...dataFilters];
                                  newWhereFilters.splice(index, 1);
                                  setDataFilters(newWhereFilters);
                                }}
                                disabled={props.disabled}
                                setFilterReady={(isReady) => {
                                  setFilterRowIdxReady(index, isReady);
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </CCol>
                  </CFormGroup>
                </>
              )}
            </CForm>
            {timeSliceAggregation === "split" && !splitDatesValid() && (
              <CAlert
                key={"specKey"}
                color="warning"
                style={{ fontSize: "0.750rem" }}
              >
                {"Split dates must be filled out under 'Advanced Options' Tab"}
              </CAlert>
            )}
          </div>
          <div
            style={{
              display: props.isAdvancedAnalyticOptions ? "none" : "inline",
            }}
          >
            <CForm>
              {/* Simple Analytic Options Form */}
              {modelLabelClassId && (
                <>
                  <CFormGroup row>
                    <CCol md="4">
                      <CLabel
                        htmlFor="sliceby-select"
                        className="col-form-label"
                      >
                        Field to slice by{" "}
                        <span className="optionaltext">(optional)</span>
                      </CLabel>
                      <br />
                      <ReactQueryLoading
                        isLoading={isDatasetColumnsLoading}
                        status={datasetColumnsStatus}
                        error={datasetColumnsError}
                      >
                        {datasetColumns && (
                          <Select
                            name="sliceby-select"
                            id="sliceby-select"
                            isMulti
                            value={sliceByColumns.map((sbc) => ({
                              value: sbc,
                              label: sbc,
                            }))}
                            onChange={(selected) => {
                              setSliceByColumns(selected.map((s) => s.value));
                            }}
                            isDisabled={props.disabled}
                            options={datasetColumns.map((dsc) => ({
                              value: dsc.field_name,
                              label: dsc.field_name,
                            }))}
                          />
                        )}
                      </ReactQueryLoading>
                    </CCol>
                    <CCol md="4">
                      <CLabel
                        htmlFor="timeslice-select"
                        className="col-form-label"
                      >
                        Analyze Across Time{" "}
                        <span className="optionaltext">(optional)</span>
                      </CLabel>
                      <br />
                      <ReactQueryLoading
                        isLoading={isDatasetColumnsLoading}
                        status={datasetColumnsStatus}
                        error={datasetColumnsError}
                      >
                        {datasetColumns && (
                          <Select
                            name="timeslice-select"
                            id="timeslice-select"
                            value={{
                              value: timeSliceColumn,
                              label: timeSliceColumn,
                            }}
                            onChange={(e) => setTimeSliceColumn(e.value)}
                            isDisabled={props.disabled}
                            options={datasetColumns.map((dsc) => ({
                              value: dsc.field_name,
                              label: dsc.field_name,
                            }))}
                          />
                        )}
                      </ReactQueryLoading>
                    </CCol>
                    {timeSliceColumn && (
                      <>
                        <CCol md="4">
                          <CLabel
                            htmlFor="timeslice-aggregation-select"
                            className="col-form-label"
                          >
                            Time Aggregation
                          </CLabel>
                          <br />
                          {datasetColumns && (
                            <CSelect
                              name="timeslice-aggregation-select"
                              id="timeslice-aggregation-select"
                              onChange={(e) => {
                                setTimeSliceAggregation(e.target.value);
                                if (
                                  e.target.value === "split" &&
                                  timeSliceSplits === null
                                ) {
                                  setTimeSliceSplits([""]);
                                }
                              }}
                              value={timeSliceAggregation}
                              disabled={props.disabled}
                            >
                              <option value="day">Day</option>
                              <option value="week">Week</option>
                              <option value="month">Month</option>
                              <option value="quarter">Quarter</option>
                              <option value="year">Year</option>
                              <option value="split">Split</option>
                            </CSelect>
                          )}
                        </CCol>
                      </>
                    )}
                  </CFormGroup>
                </>
              )}
            </CForm>
            {timeSliceAggregation === "split" && !splitDatesValid() && (
              <CAlert
                key={"specKey"}
                color="warning"
                style={{ fontSize: "0.750rem" }}
              >
                {"Split dates must be filled out under 'Advanced Options' Tab"}
              </CAlert>
            )}
          </div>
        </>
      )}
      no={() => <div>You do not have permissions to analyze datasets.</div>}
    />
  );
};

DatasetModelParamsSelector.propTypes = {
  isAdvancedAnalyticOptions: PropTypes.bool,
  datasetId: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  modelVersionId: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  onReady: PropTypes.func.isRequired,
  onNotReady: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  statsParams: PropTypes.object,
};

DatasetModelParamsSelector.defaultProps = {
  disabled: false,
  isAdvancedAnalyticOptions: true,
  statsParams: null,
};

// Record data fields can hold nested JSON (objects/arrays); rendering those
// directly as React children throws React error #31 and crashes the page.
const formatCellValue = (value) => {
  if (value !== null && typeof value === "object") {
    return JSON.stringify(value);
  }
  return value;
};

export const DatasetModelStatsResultsTable = ({
  results,
  height,
  width,
  scale,
  onRowClick,
  skipColumns,
}) => {
  const [sortColumns, setSortColumns] = useState([]);
  const columns =
    results && results[0]
      ? Object.keys(results[0]).reduce((filtered, colName) => {
          if (!skipColumns.includes(colName)) {
            // Only return column if it isn't supposed to be skipped
            filtered.push({
              key: colName,
              name: colName,
              width: "50px",
              renderCell: ({ row }) => formatCellValue(row[colName]),
            });
          }
          return filtered;
        }, [])
      : [];
  const sortedRows = useMemo(() => {
    if (sortColumns?.length === 0) {
      return results;
    }

    return [...results].sort((a, b) => {
      for (const sort of sortColumns) {
        let aVal = a[sort.columnKey];
        let bVal = b[sort.columnKey];
        if (!isNaN(aVal) && !isNaN(bVal)) {
          aVal = Number(aVal);
          bVal = Number(bVal);
        }
        const compResult = aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        if (compResult !== 0) {
          return sort.direction === "ASC" ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [results, sortColumns]);
  const dataGridStyle = {
    fontSize: scale * 100 + "%",
  };
  if (height) {
    dataGridStyle.height = height;
  }
  if (width) {
    dataGridStyle.width = width;
  }
  return (
    <DataGrid
      style={dataGridStyle}
      className="rdg-light"
      columns={columns}
      rows={sortedRows}
      defaultColumnOptions={{
        resizable: true,
        sortable: true,
      }}
      sortColumns={sortColumns}
      onSortColumnsChange={setSortColumns}
      headerRowHeight={35 * scale}
      rowHeight={35 * scale}
      onCellClick={onRowClick}
    />
  );
};

DatasetModelStatsResultsTable.propTypes = {
  results: PropTypes.array,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scale: PropTypes.number,
  onRowClick: PropTypes.func,
  skipColumns: PropTypes.array,
};
DatasetModelStatsResultsTable.defaultProps = {
  scale: 1.0,
  skipColumns: ["__id__"],
  onRowClick: () => {},
};

const DatasetModelAnalyticsSelect = (props) => {
  const [isRawPredictionsModalVisible, setIsRawPredictionsModalVisible] =
    useState(false);
  const [isDisabled, setIsDisable] = useState(false);

  useEffect(() => {
    if (
      props.status === "loading" ||
      (props.scoredCheck && !props.scoredCheck?.scoredDataRecord)
    ) {
      setIsDisable(true);
    } else if (props.scoredCheck?.scoredDataRecord) {
      setIsDisable(false);
    }
  }, [props.scoredCheck, props.status]);

  return (
    <>
      <RawPredictionsModal
        analyticId={props.analyticId}
        onReadyToRunChange={props.onReadyToRunChange}
        isRawPredictionsModalVisible={isRawPredictionsModalVisible}
        setIsRawPredictionsModalVisible={setIsRawPredictionsModalVisible}
      />
      <Stack flexDirection="row" justifyContent="flex-end" gap={1}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            props.onStatsPaneChange("cluster");
            props.onReadyToRunChange(true);
          }}
          disabled={isDisabled}
          id="cluster-analytics-button"
          data-attr="datasets:btn:cluster-analytics"
          startIcon={
            <MdOutlineScatterPlot
              style={{
                marginTop: "3.5px",
                marginBottom: "3.5px",
                marginRight: "3px",
                height: "1rem",
                width: "1rem",
              }}
            />
          }
          disableElevation
        >
          Cluster Analytics
        </Button>
        <DatasetAnalyticsExportButton
          analyticId={props.analyticId}
          isDisabled={isDisabled}
          onReadyToRunChange={props.onReadyToRunChange}
          onStatsPaneChange={props.onStatsPaneChange}
          setIsRawPredictionsModalVisible={setIsRawPredictionsModalVisible}
        />
      </Stack>
    </>
  );
};

DatasetModelAnalyticsSelect.propTypes = {
  buttonsDisabled: PropTypes.bool.isRequired,
  analyticId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  statsPane: PropTypes.string.isRequired,
  readyToRun: PropTypes.bool.isRequired,
  onStatsPaneChange: PropTypes.func,
  onReadyToRunChange: PropTypes.func,
  scoredCheck: PropTypes.string,
  status: PropTypes.any,
  datasetId: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  modelVersionId: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

DatasetModelAnalyticsSelect.defaultProps = {
  onStatsPaneChange: () => {},
  onReadyToRunChange: () => {},
};

export const DatasetModelStatsDisplay = ({
  analyticId,
  defaultBucketId,
  onStatsRunning,
  onStatsNotRunning,
  statsPane,
  readyToRun,
  onReadyToRunChange,
  setNewBucketIdInUrl,
  selectedLabels,
}) => {
  const { data: analytic } = useGetAnalytic(analyticId);
  const getAnalyticsEnabled = !!analyticId && readyToRun;

  const {
    data: statsData,
    isLoading: statsLoading,
    status: statsStatus,
    error: statsError,
  } = useGetAnalyticResults(analyticId, getAnalyticsEnabled);

  useEffect(() => {
    if (statsStatus === "success" || statsStatus === "error") {
      onStatsNotRunning();
      onReadyToRunChange(false);
    } else if (readyToRun || statsLoading) {
      onStatsRunning();
    } else {
      onStatsNotRunning();
    }
  }, [readyToRun, statsLoading, statsStatus]);

  useEffect(() => {
    if (statsData && defaultBucketId) {
      // scroll to results automatically in this case
      setTimeout(() => {
        const id = "dataset-model-stats-display";
        if (document.getElementById(id)) {
          document.getElementById(id).scrollIntoView(false);
        }
      }, 500);
    }
  }, [defaultBucketId, statsData]);

  return (
    <div id="dataset-model-stats-display">
      {(getAnalyticsEnabled || statsData || statsError) &&
        ["view", "cluster", "raw", "pivot"].includes(statsPane) && (
          <Can
            perform="dataset_data:read"
            yes={() => (
              <CCard>
                <CCardBody style={{ padding: 0, minHeight: "120px" }}>
                  {statsPane === "view" && (
                    <ReactQueryLoading
                      isLoading={statsLoading}
                      status={statsStatus}
                      error={statsError}
                    >
                      {statsStatus !== "idle" && (
                        <div style={{ minHeight: "100px" }}>
                          {statsData && (
                            <DatasetModelStatsResultsTable
                              results={statsData}
                            />
                          )}
                        </div>
                      )}
                    </ReactQueryLoading>
                  )}
                  {statsPane === "cluster" && (
                    <ReactQueryLoading
                      isLoading={statsLoading}
                      status={statsStatus}
                      error={statsError}
                    >
                      {statsStatus !== "idle" && statsData && (
                        <BucketVisPackage
                          analyticId={analyticId}
                          defaultBucketId={defaultBucketId}
                          // Pass new data here?
                          statsData={statsData}
                          setNewBucketIdInUrl={setNewBucketIdInUrl}
                          selectedLabels={selectedLabels}
                        />
                      )}
                    </ReactQueryLoading>
                  )}
                  {statsPane === "raw" && (
                    <ReactQueryLoading
                      isLoading={statsLoading}
                      status={statsStatus}
                      error={statsError}
                    >
                      {statsStatus !== "idle" && (
                        <div style={{ minHeight: "100px" }}>
                          {statsData && (
                            <pre>{JSON.stringify(statsData, null, 2)}</pre>
                          )}
                        </div>
                      )}
                    </ReactQueryLoading>
                  )}
                  {statsPane === "pivot" &&
                    analytic.config.model_params.limitResults === "topn" &&
                    analytic.config.model_params.timeSliceColumn !== null && (
                      <div>
                        <h5>POC Base Analysis </h5>
                        <br></br>
                        Use the following built-in analysis methods to get a
                        high-level overview of your Performance Objective and
                        Criteria Codes. Note that all slices and aggregations
                        will be ignored when using this feature.
                        <p></p>
                        <hr></hr>
                        <TrendCodingProduct
                          datasetId={analytic.dataset_id}
                          modelVersionId={analytic.model_version_id}
                          topN={analytic.config.model_params.resultsLimitedTo}
                          statsParams={analytic.config}
                        />
                      </div>
                    )}
                </CCardBody>
              </CCard>
            )}
          />
        )}
    </div>
  );
};

DatasetModelStatsDisplay.propTypes = {
  analyticId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultBucketId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onStatsRunning: PropTypes.func.isRequired,
  onStatsNotRunning: PropTypes.func.isRequired,
  statsPane: PropTypes.string.isRequired,
  readyToRun: PropTypes.bool.isRequired,
  onReadyToRunChange: PropTypes.func,
  setNewBucketIdInUrl: PropTypes.func,
  selectedLabels: PropTypes.array,
};

DatasetModelStatsDisplay.defaultProps = {
  onReadyToRunChange: () => {},
};

// A custom hook that builds on useLocation to parse
// the query string for you.
function useURLQueryParams() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const nullAsEmptyString = (v) => {
  if (v === null || v === undefined) {
    return "";
  }
  return v;
};

const DatasetModelStats = () => {
  const location = useLocation();
  const [lostQueryParams, setLostQueryParams] = React.useState(false);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hasBucketId = searchParams.has("bucketId");

    if (!hasBucketId) {
      setLostQueryParams(true);
    } else {
      setLostQueryParams(false);
    }
  }, [location.search]);
  let bucketId = useURLQueryParams().get("bucketId");
  if (lostQueryParams && bucketId === null) {
    bucketId = null;
  }
  const { data: bucket } = useGetBucket(bucketId);
  const [bucketInState, setBucketInState] = React.useState(null);
  useEffect(() => {
    setBucketInState(bucket);
  }, [bucket]);
  const { data: bucketAnalytic } = useGetAnalytic(bucketInState?.analytic_fk);
  const { dataset_id } = useParams();
  const [modelVersionId, setModelVersionId] = React.useState(null);
  const [statsParams, setStatsParams] = React.useState(null);
  const [statsRunning, setStatsRunning] = React.useState(false);
  const [statsPane, setStatsPane] = React.useState("");
  const [readyToRun, setReadyToRun] = React.useState(false);
  const [analyticId, setAnalyticId] = React.useState(null);
  const [isAdvancedAnalyticOptions, setIsAdvancedAnalyticOptions] =
    React.useState(false);

  const modelVersionIdLink = useSelector(
    (state) => state.datasetScoring.selectedModelVersion,
  );

  const { data: scoredCheck, status } = useGetScoredDataset(
    dataset_id,
    modelVersionId,
  );

  useEffect(() => {
    if (modelVersionIdLink) {
      setModelVersionId(modelVersionIdLink);
    }
  }, [modelVersionIdLink]);

  const {
    data: upsertedAnalytic,
    mutate: upsertAnalytic,
    // isLoading: isUpsertAnalyticCreating,
    isSuccess: isUpsertAnalyticSuccess,
    // isError: isUpsertAnalyticError,
    reset: resetUpsertAnalytic,
    // error: upsertAnalyticError,
  } = useUpsertAnalytic();

  useEffect(() => {
    // reset if not viewing a specific bucket
    if (!(bucketId && bucketInState && bucketAnalytic)) {
      // Stats params have been changed from a default bucket, eg.
      // We are not viewing a specific bucket, reset analytic
      resetUpsertAnalytic();
      setAnalyticId(null);
    }
  }, [statsParams]);

  useEffect(() => {
    // Do not attempt to upsert a new analytic when the bucketId already exists - the stats params are already set via bucket
    if (statsRunning && !bucketId) {
      let timeSlice = null;
      if (statsParams?.timeSliceColumn) {
        timeSlice = {
          field: {
            group: "dataset",
            name: statsParams?.timeSliceColumn,
          },
          sliceby: statsParams?.timeSliceAggregation,
        };
        if (statsParams?.timeSliceSplits) {
          timeSlice.split_dates = statsParams?.timeSliceSplits;
        }
      }

      upsertAnalytic({
        datasetId: dataset_id,
        modelVersionId: modelVersionId,
        modelLabelClassId: statsParams?.modelLabelClassId,
        aggregation: statsParams?.aggregation,
        sliceBys: statsParams?.sliceByColumns
          ? statsParams?.sliceByColumns.map((sbc) => ({
              group: "dataset",
              name: sbc,
            }))
          : [],
        sliceStats:
          statsParams?.sliceByStats !== "" &&
          statsParams?.sliceByColumns?.length > 0
            ? [{ name: statsParams?.sliceByStats }]
            : [],
        sliceProportional: statsParams?.sliceProportional,
        sliceExcludeFromAverage: statsParams?.sliceExcludeFromAverage,
        timeSlice: timeSlice,
        includeFirstTimePeriod: statsParams?.timeSliceColumn
          ? statsParams.includeFirstTimePeriod
          : true,
        includeLastTimePeriod: statsParams?.timeSliceColumn
          ? statsParams.includeLastTimePeriod
          : true,
        timeStats:
          statsParams?.timeSliceStats !== "" && statsParams?.timeSliceColumn
            ? [{ name: statsParams?.timeSliceStats }]
            : [],
        timeProportional: statsParams?.timeProportional,
        dataFilters: statsParams?.dataFilters,
        limitResults: statsParams?.limitResults,
        resultsLimitedTo:
          statsParams?.limitResults === "aboveprob"
            ? statsParams?.resultsLimitedTo / 100.0
            : statsParams?.resultsLimitedTo,
        benchmark:
          statsParams?.benchmarkDatasetId &&
          statsParams?.benchmarkDatasetId !== ""
            ? {
                dataset_id: statsParams?.benchmarkDatasetId,
                label_field: statsParams?.benchmarkLabelField,
                benchmark_field: statsParams?.benchmarkField,
              }
            : null,
      });
    }
  }, [statsRunning, bucketId]);

  useEffect(() => {
    if (isUpsertAnalyticSuccess && upsertedAnalytic) {
      setAnalyticId(upsertedAnalytic.id);
    }
  }, [isUpsertAnalyticSuccess, upsertedAnalytic]);

  useEffect(() => {
    if (bucketId && bucketInState && bucketAnalytic) {
      // We are viewing a specific bucket and analytic that already exists
      // URL param for bucketId provided, default the analyticId, bucketSelections (stats params)... etc
      // No need to reset analytic id
      setModelVersionId(bucketAnalytic.model_version_id);
      setStatsParams({
        modelLabelClassId: nullAsEmptyString(
          bucketAnalytic.model_label_class_id,
        ),
        limitResults:
          normalizeToNull(bucketAnalytic.config.model_params.limit_results) ||
          "aboveprob",
        resultsLimitedTo: bucketId
          ? bucketAnalytic.config.model_params.results_limited_to * 100 // convert decimal to percent value if looking at bucket and not analytic since results_limited_to stored as decimal in db
          : bucketAnalytic.config.model_params.results_limited_to,
        aggregation:
          normalizeToNull(bucketAnalytic.config.aggregation) || "count",
        sliceByColumns: bucketAnalytic.config.slice_by.map((v) => v.name),
        sliceByStats:
          normalizeToNull(bucketAnalytic.config.slice_stats[0]?.name) ||
          "rel_diff",
        sliceProportional: bucketAnalytic.config.slice_proportional ?? true,
        sliceExcludeFromAverage:
          bucketAnalytic.config.slice_exclude_from_average ?? true,
        timeSliceColumn: nullAsEmptyString(
          bucketAnalytic.config.time_slice?.field?.name,
        ),
        timeSliceAggregation:
          normalizeToNull(bucketAnalytic.config.time_slice?.sliceby) || "month",
        timeSliceSplits: normalizeToNull(
          bucketAnalytic.config.time_slice?.split_dates,
        ),
        includeFirstTimePeriod:
          bucketAnalytic.config.include_first_time_period ?? true,
        includeLastTimePeriod:
          bucketAnalytic.config.include_last_time_period ?? true,
        timeSliceStats:
          normalizeToNull(bucketAnalytic.config.time_stats[0]?.name) ||
          "rel_diff",
        timeProportional: bucketAnalytic.config.time_proportional ?? true,
        dataFilters: bucketAnalytic.config.filters || [],
        benchmarkDatasetId: nullAsEmptyString(
          bucketAnalytic.config.benchmark?.dataset_id,
        ),
        benchmarkLabelField: nullAsEmptyString(
          bucketAnalytic.config.benchmark?.label_field,
        ),
        benchmarkField: nullAsEmptyString(
          bucketAnalytic.config.benchmark?.benchmark_field,
        ),
      });
      setAnalyticId(bucketAnalytic.id);
      setStatsPane("cluster");
      setReadyToRun(true);
    }
  }, [bucketId, bucketInState, bucketAnalytic]);

  const modelVersionSelector = (
    <ModelVersionSelector
      datasetId={dataset_id}
      modelVersionId={modelVersionId}
      disabled={!!bucketId}
      onModelVersionId={setModelVersionId}
      setSuccessScore={() => {}} //no-op
    />
  );
  const datasetInfo = (
    <CCard>
      <CCardHeader>
        <h5>Dataset</h5>
      </CCardHeader>
      <CCardBody style={{ padding: "10px 20px" }}>
        <DatasetInfo dataset_id={dataset_id} />
      </CCardBody>
    </CCard>
  );
  const datasetModelParamsSelector = (
    <DatasetModelParamsSelector
      isAdvancedAnalyticOptions={isAdvancedAnalyticOptions}
      disabled={statsRunning || !!bucketId}
      datasetId={dataset_id}
      modelVersionId={modelVersionId}
      statsParams={statsParams}
      onReady={(stats) => {
        setStatsParams(stats);
      }}
      onNotReady={() => {
        setStatsParams(null);
      }}
    />
  );

  return (
    <CContainer fluid style={{ marginTop: "1%" }}>
      <CRow>
        <CCol xs="12" md={"4"}>
          <CCol xs="12">{modelVersionSelector}</CCol>
          <CCol xs="12">{datasetInfo}</CCol>
        </CCol>
        <CCol xs="12" md="8">
          {modelVersionId && (
            <CCard data-testid="analytic-options-card">
              <CCardHeader>
                <h5 style={{ float: "left" }}>Analytic Options</h5>
                <div style={{ float: "right" }}>
                  <div style={{ float: "left" }}>
                    <TrendCodingProductPatchModalButton />
                  </div>
                  <div style={{ float: "right", marginLeft: "15px" }}>
                    <CLabel
                      htmlFor="advanced-analytic-options-switch"
                      style={{ marginRight: "5px" }}
                    >
                      <i>Advanced Options</i>
                    </CLabel>
                    <div style={{ float: "right" }}>
                      <CSwitch
                        id="advanced-analytic-options-switch"
                        color={"info"}
                        size={"sm"}
                        checked={isAdvancedAnalyticOptions}
                        onChange={(e) => {
                          setIsAdvancedAnalyticOptions(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </CCardHeader>
              <CCardBody>{datasetModelParamsSelector}</CCardBody>
              <CCardFooter>
                <DatasetModelAnalyticsSelect
                  buttonsDisabled={!statsParams?.modelLabelClassId} // at least the modelLabelClassId is required
                  analyticId={analyticId}
                  statsPane={statsPane}
                  readyToRun={readyToRun}
                  onStatsPaneChange={setStatsPane}
                  onReadyToRunChange={setReadyToRun}
                  scoredCheck={scoredCheck}
                  status={status}
                  datasetId={dataset_id}
                  modelVersionId={modelVersionId}
                />
              </CCardFooter>
            </CCard>
          )}
        </CCol>
      </CRow>
      {scoredCheck && !scoredCheck?.scoredDataRecord && <ScoredDataError />}
      <DatasetModelStatsDisplay
        analyticId={analyticId}
        defaultBucketId={bucketId}
        statsPane={statsPane}
        readyToRun={readyToRun}
        onReadyToRunChange={setReadyToRun}
        onStatsRunning={() => {
          setStatsRunning(true);
        }}
        onStatsNotRunning={() => {
          setStatsRunning(false);
        }}
        enabled={!!statsParams?.modelLabelClassId} // at least the modelLabelClassId is required
        selectedLabels={bucket?.selectedLabels}
      />
    </CContainer>
  );
};

export default DatasetModelStats;
